import { ButtonText } from '@components/Text/ButtonText';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  overflow: hidden;

  padding-top: 24px;
`;

export const Line = styled.div`
  margin-top: 12px;
  grid-gap: 8px;
`;

export interface ITagPill {
  deleted: boolean;
  color?: string;
}

export const Tag = styled.div<ITagPill>`
  height: 30px;
  padding: 0 12px;
  border-radius: 15px;
  background: ${({ deleted, color }) => {
    if (deleted) return '#ffe2e2';
    if (color?.toUpperCase() === '#474D66') return '#edeff4';
    if (color) return color;
    return '#edeff4';
  }};
  color: ${({ color, deleted }) => {
    if (color === '#E7E4F9') return '#524988';
    if (color === '#DCF2EA') return '#317159';
    if (color === '#FFEFD2') return '#66460D';
    if (color === '#D3F5F7') return '#0F5156';
    if (color === '#F8E3DA') return '#85462B';
    if (color === '#FBDDF3') return '#8E3374';
    if (color === '#F9DADA') return '#7D2828';
    if (color === '#E6EDFF') return '#1F3D99';
    if (deleted) return '#833c3c';
    return '#474d66';
  }};
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  width: min-content;
  cursor: pointer;
  margin: 4px;
  &.rm-m {
    margin: 0;
  }
  &.rm-cur {
    cursor: unset;
  }
`;

export const TagNumber = styled.div`
  height: 30px;
  padding: 0 12px;
  border-radius: 15px;
  background: #edeff4;
  font-size: 14px;
  font-weight: 500;
  color: #8f95b2;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  width: min-content;
  cursor: pointer;
  margin: 4px;
`;

export const ShowLess = styled.div`
  margin-top: 20px;
  cursor: pointer;
  color: #8f95b2;
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  width: 100%;
  text-align: right;
`;

export const Done = styled(ButtonText)`
  width: 100%;
  && {
    text-align: right;
  }
` as typeof ButtonText;

export const NoTags = styled.div`
  color: #696f8c;
  font-size: 14px;
  font-weight: 400;
`;

export const AddTag = styled.a`
  color: #1371fe;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
`;

export const DeleteIcon = styled.div`
  height: 20px;
  margin-left: 10px;
`;
